<template>
    <div class="gallery-controls" v-if="itemsLength > 1">
        <div
            v-if="showDots"
            class="gallery-dots"
            aria-label="Gallery pagination"
        >
            <button
                v-for="(_, index) in scrollSnaps"
                :key="index"
                class="gallery-dot"
                :class="{ 'gallery-dot--active': selectedScrollSnap === index }"
                type="button"
                :aria-label="`Go to ${itemLabel} ${index + 1}`"
                @click.stop="$emit('scroll-to', index)"
            />
        </div>
        <GalleryArrowButtons
            v-if="controlsPosition === C.BOTTOM"
            :control-position="controlsPosition"
            :item-label="itemLabel"
            @next="$emit('next')"
            @previous="$emit('previous')"
        />
    </div>
</template>

<script>
import {GalleryControlsPosition, GalleryLayout} from "@/scripts/common/enums.js";
import GalleryArrowButtons from "@/scripts/sections/modules/gallery/GalleryArrowButtons.vue";

export default {
    name: "GalleryControls",
    components: {
        GalleryArrowButtons
    },
    props: {
        itemsLength: {
            type: Number,
            default: 0
        },
        scrollSnaps: {
            type: Array,
            default: () => []
        },
        selectedScrollSnap: {
            type: Number,
            default: 0
        },
        controlsPosition: {
            type: String,
            default: GalleryControlsPosition.SIDES
        },
        layoutType: {
            type: String,
            default: null
        },
        itemLabel: {
            type: String,
            default: "image"
        }
    },
    emits: ["previous", "next", "scroll-to"],
    data() {
        return {
            C: GalleryControlsPosition,
            L: GalleryLayout
        }
    },
    computed: {
        showDots() {
            return this.layoutType !== this.L.CAROUSEL;
        }
    }
}
</script>

<style scoped lang="scss">
.gallery-controls {
    display: flex;
    align-items: center;
    justify-content: center;

    &:has(.gallery-bottom-arrows) {
        @media (min-width: 1024px) {
            justify-content: space-between;
        }
    }
}

.gallery-dots {
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 6px;
    border-radius: 32px;
}

.gallery-dot {
    width: 8px;
    height: 8px;
    aspect-ratio: 1/1;
    padding: 0;
    border: 0;
    border-radius: 999px;
    cursor: pointer;

    &:focus {
        outline: none;
    }
}
</style>
